export default {
  fields: {
    price: 'Hinta',
    tax: 'Vero',
    visible_to: 'Näkyy käyttäjille',
  },
  buttons: {
    add_price: '+ Lisää hinta',
  },
};
